export default "__VITE_ASSET__1ProQTMx__"